import { AES, enc } from 'crypto-js';
import getFingerprint from './fingerprint';
import { IsNullOrUndefined } from './valid';
import { jwtDecode } from 'jwt-decode'; // 修改這行


const secureKey = getFingerprint().toString();

export const GetEncryptedString = (val) => {
  if (IsNullOrUndefined(val)) return null;

  return AES.encrypt(val, secureKey).toString();
};

export const GetDecryptedString = (val) => {
  if (IsNullOrUndefined(val)) return null;

  try {
    return AES.decrypt(val, secureKey).toString(enc.Utf8);
  } catch (ex) {
    return null;
  }
};

export const GetEncryptObject = (obj) => {
  if (IsNullOrUndefined(obj)) return null;

  return AES.encrypt(JSON.stringify(obj), secureKey).toString();
};

export const GetDecryptedObject = (val) => {
  if (IsNullOrUndefined(val)) return null;

  try {
    const decryptedObject = AES.decrypt(val, secureKey).toString(enc.Utf8);
    return decryptedObject ? JSON.parse(decryptedObject) : null;
  } catch (ex) {
    return null;
  }
};

// 新增 JWT 解碼函數
export const decodeJWT = (token) => {
  if (IsNullOrUndefined(token)) return null;

  try {
    return jwtDecode(token); // 使用 jwtDecode 而不是 jwt_decode
  } catch (ex) {
    console.error('JWT 解碼失敗:', ex);
    return null;
  }
};

